<span class="btn badge badge-primary me-2 badge-class {{badgeClass}}
    {{ badgeColor ? 'badge-' + badgeColor : '' }}" (click)="badgeClicked($event)">
    {{badgeText}}
  <button class="btn badge ms-1 delete-btn" (click)="buttonClicked($event)">
        <i class="bi bi-x-lg bold delete-icon"></i>
    </button>
</span>
